module.exports = __webpack_public_path__ + "img/bg.76e8508b.png";